import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeEarningListService = (
  params: Types.EmployeeEarningListRequest
) =>
  RestAPIClient.call<Types.EmployeeEarningListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeEarningCreateService = (
  params: Types.EmployeeEarningCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeEarning>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeEarningUpdateService = (
  params: Types.EmployeeEarningUpdateRequest
) =>
  RestAPIClient.call<Types.EmployeeEarning>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeEarningDeleteService = (id: string) =>
  RestAPIClient.call<Types.EmployeeEarning>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeEarningDetailService = (id: string) =>
  RestAPIClient.call<Types.EmployeeEarning>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeEarningImportService = (
  data: Types.EmployeeEarningImportRequest
) =>
  RestAPIClient.call<Types.EmployeeEarningImportResponse>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Import}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
